import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings2 } from 'lucide-react';
import { Typography } from '@mui/material';
import lumaLogo from '../assets/luma-logo.png';
import { MegaphoneIcon } from '@phosphor-icons/react';
const Header: React.FC = () => {
  const navigate = useNavigate();


  return (
    <>
      <header className="bg-[#F5F3F0] text-theme-dark flex items-center justify-center fixed left-0 right-0 z-50 border-b-[0.5px] border-[#2B2E4A] px-4 h-[64px]">
        <div className="flex items-center">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img
              src={lumaLogo}
              alt="Luma Logo"
              style={{
                height: '24px',
                filter: 'brightness(0) saturate(100%) invert(19%) sepia(19%) saturate(1234%) hue-rotate(197deg) brightness(94%) contrast(88%)'
              }}
            />
            <Typography

              sx={{
                color: "#2B2E4A",
                fontSize: '24px',
                fontWeight: '700',
              }}
            >
              Luma
            </Typography>
          </div>
        </div>
        <div className="flex items-center gap-1  ">

          <button
            onClick={() => navigate('/settings')}
            className="p-2 hover:bg-black/5 rounded-full transition-colors hidden md:block"
          >
            <Settings2 size={20} color="#2B2E4A" />
          </button>
        </div>
      </header>

    </>
  );
};

export default Header;
